import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "./ui/sheet";
import { fmtDate } from "../lib/format";

function Row({ label, value }) {
  return (
    <div className="grid grid-cols-[160px_1fr] gap-3 py-2 border-b text-sm" style={{ borderColor: "var(--cv-line)" }}>
      <div className="small-caps text-[11px] font-bold" style={{ color: "var(--cv-charcoal-soft)" }}>{label}</div>
      <div style={{ color: "var(--cv-charcoal)" }} className="break-all">
        {value === true ? "Yes" : value === false ? "No" : value ?? "—"}
      </div>
    </div>
  );
}

function looksLikeDate(s) {
  return typeof s === "string" && /\d{4}-\d{2}-\d{2}T/.test(s);
}

export default function RecordSheet({ open, onOpenChange, record, title }) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent className="w-full sm:max-w-[520px] overflow-y-auto" data-testid="record-sheet">
        <SheetHeader>
          <SheetTitle className="font-serif-display text-2xl" style={{ color: "var(--cv-crimson)" }}>
            {title || "Record"}
          </SheetTitle>
          <SheetDescription>Full record detail — the last leg of the drill-down.</SheetDescription>
        </SheetHeader>
        <div className="mt-3">
          {record &&
            Object.entries(record).map(([k, v]) => (
              <Row
                key={k}
                label={k.replace(/_/g, " ")}
                value={looksLikeDate(v) ? fmtDate(v) : typeof v === "object" ? JSON.stringify(v) : String(v)}
              />
            ))}
        </div>
      </SheetContent>
    </Sheet>
  );
}
